// Catálogo de funciones que un plan puede incluir. Lo que no está en el plan toma el valor por defecto.
export const FEATURE_GROUPS = [
  { id: 'gestion', label: 'Gestión de personas', items: [
    { key: 'vacaciones', label: 'Vacaciones', def: true },
    { key: 'licencias', label: 'Licencias', def: true },
    { key: 'tareas', label: 'Tareas', def: true },
    { key: 'horas_extra', label: 'Horas extra', def: true },
    { key: 'excepciones', label: 'Excepciones de horario', def: true },
    { key: 'alertas', label: 'Alertas automáticas', def: true },
    { key: 'analisis', label: 'Análisis', def: true },
    { key: 'feriados', label: 'Calendario de feriados', def: true },
    { key: 'adelantos', label: 'Adelantos de sueldo', def: true },
    { key: 'pago_hora', label: 'Pago por hora (personal convocado)', def: true },
    { key: 'import_excel', label: 'Importar personas desde Excel', def: true },
  ] },
  { id: 'marcacion', label: 'Formas de marcar', items: [
    { key: 'method_qr', label: 'QR en pantalla', def: true },
    { key: 'method_kiosk', label: 'Kiosco con código personal', def: true },
    { key: 'biometric_server', label: 'Huella verificada en el servidor', def: true },
    { key: 'network_restrict', label: 'Restricción por red del local', def: true },
  ] },
  { id: 'empleado', label: 'Lo que ve el empleado en su app', items: [
    { key: 'emp_calendario', label: 'Calendario', def: true },
    { key: 'emp_historial', label: 'Historial de marcaciones', def: true },
    { key: 'emp_sueldo', label: 'Sueldo y recibos', def: true },
    { key: 'emp_ficha', label: 'Mi ficha', def: true },
  ] },
  { id: 'extras', label: 'Administración y soporte', items: [
    { key: 'payroll', label: 'Liquidación de sueldos y recibos', def: false },
    { key: 'export', label: 'Exportación de reportes', def: false },
    { key: 'export_liquidacion', label: 'Exportación para el estudio contable', def: false },
    { key: 'custom_email', label: 'Mails con el nombre de la organización', def: false },
    { key: 'custom_domain', label: 'Mails desde el dominio propio', def: false },
    { key: 'brand_custom', label: 'Marca propia: logo y color', def: true },
    { key: 'white_label', label: 'Ocultar la marca de Gestión360', def: false },
    { key: 'priority_support', label: 'Soporte prioritario', def: false },
  ] },
];
export const FEATURES = FEATURE_GROUPS.flatMap((g) => g.items);
const DEF = Object.fromEntries(FEATURES.map((f) => [f.key, f.def]));

// ¿Está incluida esta función? features = plan + ajustes de la organización
export const hasFeature = (features, key) => {
  const v = features?.[key];
  return v === undefined || v === null ? (DEF[key] ?? true) : !!v;
};
export const featureLabel = (key) => FEATURES.find((f) => f.key === key)?.label || key;
export const includedList = (features) => FEATURES.filter((f) => hasFeature(features, f.key)).map((f) => f.label);
